<template>
    <!-- Regular Carton Display -->
    <div class="carton-item" v-if="currentCarton">
        <div class="carton-image">
            <v-img
                v-if="currentCarton.img"
                :src="currentCarton.img"
                height="60"
                width="60"
                contain
                class="carton-img"
            >
                <template v-slot:placeholder>
                    <div class="image-placeholder">
                        <v-icon size="24" color="brown">mdi-package-variant</v-icon>
                    </div>
                </template>
            </v-img>
            <div v-else class="no-image-placeholder">
                <v-icon size="24" color="brown">mdi-package-variant</v-icon>
            </div>
        </div>
        
        <div class="carton-details">
            <div class="carton-name">{{ currentCarton.title || currentCarton.sku }}</div>
            <div class="carton-sku">{{ currentCarton.sku }}</div>
        </div>
    </div>
    
    <!-- Empty State for Splittable Orders -->
    <div 
        v-else-if="currentCarton === null"
        class="split-required-state"
    >
        <div class="split-icon">
            <v-icon size="24" color="orange darken-2">mdi-package-variant-closed</v-icon>
        </div>
        <div class="split-details">
            <div class="split-title">Paket aufteilung erforderlich</div>
            <div class="split-subtitle">Kein passender Karton gefunden</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CartonItem',
    props: {
        currentCarton: {
            type: Object,
            default: () => null
        }
    }
}
</script>

<style scoped>
.carton-item {
    display: flex;
    align-items: center;
    gap: 12px;
    background-color: #ffdcbb;
    border: 1px solid #d7ccc8;
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.carton-image {
    flex-shrink: 0;
}

.carton-img {
    border-radius: 6px;
    border: 1px solid #e0e0e0;
    background-color: #f8f5f0;
}

.image-placeholder,
.no-image-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    background-color: #f8f5f0;
    border-radius: 6px;
    border: 1px solid #e0e0e0;
}

.carton-details {
    flex: 1;
    min-width: 0;
}

.carton-name {
    font-size: 14px;
    font-weight: 600;
    color: #3e2723;
    line-height: 1.2;
    margin-bottom: 4px;
    word-break: break-word;
}

.carton-sku {
    font-family: 'Roboto Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    color: #8d6e63;
    background-color: #efebe9;
    padding: 2px 6px;
    border-radius: 4px;
    display: inline-block;
}

/* Empty State for Splittable Orders */
.split-required-state {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    background-color: #fff3e0;
    border: 2px dashed #ff9800;
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.split-icon {
    flex-shrink: 0;
}

.split-details {
    flex: 1;
    min-width: 0;
}

.split-title {
    font-size: 14px;
    font-weight: 600;
    color: #e65100;
    line-height: 1.2;
    margin-bottom: 4px;
    word-break: break-word;
}

.split-subtitle {
    font-size: 12px;
    color: #ff9800;
    line-height: 1.2;
}
</style>